export enum TypoVariant {
  body = 'body',
  display = 'display',
  heading = 'heading',
  numeric = 'numeric',
}
export type TypoVariantType = `${TypoVariant}`
